import React, { createContext, useContext, useEffect, useState } from "react";
import { postStoreCart, AddWishlist, RemoveWishlist } from "../apiservices/ApiServices";

const CartWishlistContext = createContext();

export const CartWishlistProvider = ({ children }) => {
    const [cart, setCart] = useState([]);
    const [wishlist, setWishlist] = useState(new Set());
    const [isLogin, setIsLogin] = useState(false);
    const [isCart, setIsCart] = useState(false);
    const [isSearchBox, setIsSearchBox] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem('userToken')) {
            setIsLogin(false);
        }
        else {
            setIsLogin(true);
        }

    }, []);

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCart(storedCart);
    }, []);

    const setWishlistData = (wishlistData) => {
        const wishlistSet = new Set(wishlistData.map(item => item.sku_id));
        setWishlist(wishlistSet);
    };

    const postCartData = async (postdata) => {
        try {
            const res = await postStoreCart(postdata);
        } catch (error) {
            console.log(error);
        }
    };

    const addToCart = async (skuid) => {
        const newProduct = {
            sku_id: skuid,
            quantity: 1,
        };

        if (isLogin) {
            postCartData([newProduct]);
        }

        const existingProduct = cart.find(item => item.sku_id === skuid);
        let updatedCart;
        if (existingProduct) {
            updatedCart = cart.map(item => item.sku_id === skuid ? { ...item, quantity: item.quantity + 1 } : item);
        } else {
            updatedCart = [...cart, newProduct];
        }
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        setCart(updatedCart);
        window.dispatchEvent(new Event("storage"));
    };

    const addToWishlist = async (skuid) => {
        if (!isLogin) { return; }

        try {
            await AddWishlist({ sku_id: skuid });
            setWishlist(prev => {
                const newSet = new Set(prev);
                newSet.add(skuid);
                return newSet;
            });
        } catch (error) {
            console.log(error);
        }
    };

    const removeWishlist = async (skuid) => {
        if (!isLogin) { return; }

        try {
            await RemoveWishlist(skuid);
            setWishlist(prev => {
                const newSet = new Set(prev);
                newSet.delete(skuid);
                return newSet;
            });
        } catch (error) {
            console.log(error);
        }
    };

    const toggleWishlist = (skuid) => {
        if (wishlist.has(skuid)) {
            removeWishlist(skuid);
        } else {
            addToWishlist(skuid);
        }
    };

    return (
        <CartWishlistContext.Provider value={{
            cart,
            setCart,
            wishlist,

            isLogin,
            setIsLogin,

            isCart,
            setIsCart,

            addToCart,

            addToWishlist,
            removeWishlist,
            toggleWishlist,

            isSearchBox,
            setIsSearchBox,

            setWishlistData,
        }}>{children}</CartWishlistContext.Provider>
    );
};

export const useCartWishlist = () => {
    return useContext(CartWishlistContext);
};